/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Breadcrumbs, BreadcrumbsProps } from '@squiz/sds';
import { DxpScreen } from 'apps/console-core/src/Components/DxpScreen/DxpScreen';
import { useCapabilityBreadcrumbs } from 'apps/console-core/src/Hooks/UseCapabilityBreadcrumbs/UseCapabilityBreadcrumbs';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CDP_STRINGS } from '../../Constants/Strings.constants';
import { SegmentInsightsView } from './elements/SegmentInsightsView/SegmentInsightsView';

/**
 * The Single Customer View Segment Insights screen.
 * @export
 * @returns {JSX.Element} The `<SegmentInsights />` component.
 */
export const SegmentInsights = (): JSX.Element => {
  const { t } = useTranslation();

  // Labels
  const labels = useMemo(() => {
    return {
      heading: t(CDP_STRINGS.segmentInsights),
    };
  }, [t]);

  // Breadcrumbs
  const capabilityBreadcrumbs = useCapabilityBreadcrumbs();
  const breadcrumbProps: BreadcrumbsProps = {
    currentPageName: labels.heading,
    links: capabilityBreadcrumbs,
  };
  const breadcrumbs = <Breadcrumbs {...breadcrumbProps} data-id="scv-customers-breadcrumbs" />;

  const screenHeading = labels.heading;
  const screenContent = (
    <>
      <SegmentInsightsView />
    </>
  );

  return (
    <DxpScreen breadcrumbs={breadcrumbs} heading={screenHeading}>
      {screenContent}
    </DxpScreen>
  );
};
